angular.module('component.bulkActions')
  .component(
    'resultsOverview', {
      templateUrl: 'app/components/bulk-actions/components/results-overview.html',
      controller: ['$translate', function($translate) {
        var ctrl = this;

        function update(meta) {
          if (_.isUndefined(meta) || _.isEmpty(meta) || !meta) {
            return;
          }

          ctrl.readableMeta = [
            {
              name: $translate.instant('Records created'),
              value: meta.created
            },
            {
              name: $translate.instant('Records deleted'),
              value: meta.deleted
            },
            {
              name: $translate.instant('Errors'),
              value: meta.errors,
              class: 'text-danger'
            },
            {
              name: $translate.instant('Existing records'),
              value: meta.exists || meta.updated
            },
            {
              name: $translate.instant('Existing records updated'),
              value: meta.updated
            },
            {
              name: $translate.instant('Existing records not updated'),
              value: meta.no_changes
            },
            {
              name: $translate.instant('Total processed'),
              value: meta.processed,
              class: 'text-success'
            }
          ];
        }

        this.$onInit = function() {
          update(ctrl.meta);
        };

        this.$onChanges = function(changes) {
          update(changes.meta.currentValue);
        };
      }],
      bindings: {
        meta: '<'
      }
    });
